import { lazy } from 'react';
export const Tasks = lazy(() => import('./Tasks'));
